import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchPublicSettings } from "@/lib/api";

const DEFAULTS = {
  google_adsense_publisher_id: "",
  google_adsense_slot_sidebar: "",
  google_adsense_slot_inline: "",
  amazon_associate_tag: "justairfry-20",
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });
export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const s = await fetchPublicSettings();
      setSettings({ ...DEFAULTS, ...s });
    } catch {
      // ignore — fall back to defaults
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Inject AdSense main script once when publisher ID is set
  useEffect(() => {
    const pubId = settings.google_adsense_publisher_id;
    if (!pubId || typeof document === "undefined") return;
    if (document.querySelector(`script[data-jaf-adsense]`)) return;
    const s = document.createElement("script");
    s.async = true;
    s.crossOrigin = "anonymous";
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${pubId}`;
    s.setAttribute("data-jaf-adsense", "1");
    document.head.appendChild(s);
  }, [settings.google_adsense_publisher_id]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}
